export default "__VITE_ASSET__ae1b79df__"